import api from 'api'

type GetCompanyFileFieldsResponseField = {
  page: number
  name: string
  fieldType: 'text' | 'checkbox' | string
}

type GetCompanyFileFieldsResponse = {
  fields: GetCompanyFileFieldsResponseField[]
}

export async function getCompanyFileFields(companyId: number, fileId: number) {
  const response = await api.get<GetCompanyFileFieldsResponse>(
    `/admin/company/${companyId}/files/${fileId}/fields`
  )
  return response.data
}
